import React from "react";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

export default function WhatsupChat() {
    return (
        <a
            href="https://wa.me/38348300800"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-[calc(48px+env(safe-area-inset-bottom,0px))] left-4 md:bottom-6 md:left-6 bg-white text-black hover:bg-gray-100 border border-gray-300 p-3 md:p-4 rounded-full shadow-md transition-all duration-300 z-50 flex items-center justify-center"
            title="Chat with us on WhatsApp"
        >
            <WhatsAppIcon
                style={{
                    fontSize: "24px",
                }}
                className="md:w-7 md:h-7"
            />
        </a>
    );
}
